module.exports = __webpack_public_path__ + "static/media/sq_sicepat.68ec29e7.png";